import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SearchService } from '../../../shared/services/search.service';
import { Utility } from '../../../shared/entities/utils';
import { ColDef, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { MeasurementsDataService } from '../../../shared/services/measurements-data.service';
import { SplitterModule } from 'primeng/splitter';


export interface QuantityElementData {
  customerpo: string;
  customerarticleno: string;
  orderpost: string;
  duedate: string;
  notional: string;
  inproduction: string;
  finished: string;
  sent: string;
  invoiced: string;
}

@Component({
  selector: 'app-quantity-data',
  standalone: true,
  imports: [AgGridModule, SplitterModule],
  templateUrl: './quantity-data.component.html',
  styleUrl: './quantity-data.component.scss'
})
export class QuantityDataComponent {
  @ViewChild('agGrid3', { static: true }) agGrid3?: AgGridAngular;
  @Input() orderPost: any;
  @Output() stockProjValue:EventEmitter<any>=new EventEmitter<any>();
  private gridApiQunatity!: GridApi;
  dataSourceQuantity: any;
  ELEMENT_DATA_QUANTITY: QuantityElementData[] = [];
  colDefsQunatity: ColDef[] = [];
  Unit: any;
  gridOptionsQunatity: GridOptions = {

    suppressCellFocus: true,
    suppressScrollOnNewData: true,
    suppressScrollWhenPopupsAreOpen: true

  };
  measuremntSystem: string = '';
  constructor(private _searchService: SearchService, private ngZone: NgZone,private spinner: NgxSpinnerService, private measurementsDataService: MeasurementsDataService, private cd: ChangeDetectorRef) {
    // this.spinner.show()
    this.Unit = this.measurementsDataService.regionMeasurementUnits()
    this.measurementsDataService.getMeasurementsData.subscribe((res: any) => {
      this.measuremntSystem = res;
    }
    )
   
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.ELEMENT_DATA_QUANTITY=[];
    this.dataSourceQuantity=[]
    if(this.orderPost.customerReference){
      this.ngZone.run(() => {
        this.getQunatityStatusData();
      });
      
    }
    this.cd.detectChanges();
  }
  onSortChangedQuantity(event: any) {
    const sortModelQuantity = event.api.sortController.getSortModel();
  }
  onGridReadyQuantity(params: GridReadyEvent) {
    this.gridApiQunatity = params.api;
  }

intializaeColoumnQuantity(){
  this.colDefsQunatity = [
    { field: "salesOrderNumber", headerName: "Order Post", flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true},
    // { field: "customerOrderNumber", headerName: "Customer PO", flex: 1, wrapHeaderText:true ,autoHeaderHeight:true },
    // { field: "customerArticleNumber", headerName: "Customer Article Number", flex: 1, wrapHeaderText:true ,autoHeaderHeight:true},
    { field: "customerReference", headerName: "Customer Refrence", flex: 1, wrapHeaderText: true, autoHeaderHeight: true },
    { field: "dueDate", headerName: "Due Date", flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true},
    { field: "notional", headerName: `Notional (${this.Unit.weight})`, flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true},
    { field: "inProduction", headerName: `In Production (${this.Unit.weight})`, flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true},
    { field: "finished", headerName: `Finished (${this.Unit.weight})`, flex: 1, wrapHeaderText:true ,autoHeaderHeight:true },
    { field: "sent", headerName: `Dispatch (${this.Unit.weight})`, flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true},
    { field: "invoiced", headerName: `Invoiced (${this.Unit.weight})`, flex: 1 , wrapHeaderText:true ,autoHeaderHeight:true}
  ]
}

  ngOnInit(): void {

this.intializaeColoumnQuantity()

  }
  getQunatityStatusData() {
    // 11024789
    this.spinner.show();
    this._searchService.getOdinQuantityStausData(this.orderPost.customerReference).subscribe((res: any) => {
    // this._searchService.getOdinQuantityStausData("11024789").subscribe((res: any) => {
    this.spinner.hide();
      res.content.forEach((element: any) => {
        if (this.measuremntSystem === 'US_CUSTOMARY_UNITS') {
          element.notional =element.notional? Utility.convertEUTonToUSTon(element.notional):'';
          element.inProduction =  element.inProduction?Utility.convertEUTonToUSTon(element.inProduction):'';
          element.finished =  element.finished?Utility.convertEUTonToUSTon(element.finished):'';
          element.sent =element.sent ? Utility.convertEUTonToUSTon(element.sent):'';
          element.invoiced = element.invoiced?Utility.convertEUTonToUSTon(element.invoiced):'';
        }

       
        this.ELEMENT_DATA_QUANTITY.push(element);
      });
      this.dataSourceQuantity = this.ELEMENT_DATA_QUANTITY;
      //  console.log("this.dataSourceQuantity",this.dataSourceQuantity)
    this.stockProjValue.emit(this.dataSourceQuantity.stockProjections);
    },(err)=>{
      this.spinner.hide();
    });
   
    this.cd.detectChanges()
  }

}

